import DeklaracjaLayout from "../_deklaracjaLayout";

export default function Kontakt(props) {
  let Miasto = props.miasto;
  let Podatek = props.podatek;

  return (
    <DeklaracjaLayout miasto={Miasto} podatek={Podatek}></DeklaracjaLayout>
  );
}
